/* Plays muted autoplay videos (rendered by snippets/video-sd.liquid) only while on screen.
   Nothing downloads until the video is near the viewport (preload="none" until then). */
(function () {
  function init(root) {
    var vids = (root || document).querySelectorAll('video[data-vt-autoplay]');
    if (!vids.length) return;
    var play = function (v) {
      if (v.preload !== 'auto') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { if (!v.__vtObserved) { v.__vtObserved = true; io.observe(v); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
